import React, {useEffect, useState} from "react";
import {IPage, pageEffect} from "../App";
import remarkGfm from "remark-gfm";
import rehypeSlug from "rehype-slug";
import ReactMarkdown from "react-markdown";
import {useLocation} from "react-router-dom";

// Convert single newlines to double newlines to preserve paragraph breaks in markdown
const preserveLineBreaks = (text: string): string => {
    if (!text) return "";
    return text
        .replace(/\r\n/g, '\n')  // Normalize line endings
        .replace(/\n(?!\n)/g, '\n\n');  // Single newline -> double newline
};


export const Pages = (props: any) => {
  const {slug} = props;

  return (
    <>
      <Page slug={slug}/>
    </>
  )
}

export const English = (props: any) => {
  const {slug} = props;

  return (
    <>
      <Page slug={slug}/>
    </>
  )
}

export const Calendar = (props: any) => {
  const {slug} = props;

  return (
    <>
      <Page slug={slug}/>
    </>
  )
}

export const Page = (props: any) => {
  const {slug} = props;
  const [page, setPage] = useState<IPage>()
  const text = page ? page.description : ""
  const alt = page ? page.title : ""
  const imgUrl = page ? page.cover_photo : null

  const location = useLocation()
  useEffect(() => {
    pageEffect(slug, setPage)
  }, [])

  return (
    <PageView text={text} imgUrl={imgUrl} alt={alt} location={location}/>
  )
}

const PageView = (props: any) => {
  const {text, imgUrl, alt} = props;

  return (
    <main>
      <section className="upcoming-events">
        <article>
          <div className="wide-margin">
            <div>
              {imgUrl ? <img src={imgUrl} alt={alt}/> : null}
            </div>
            {
              <ReactMarkdown children={preserveLineBreaks(text)} remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeSlug]}/>
            }
          </div>
        </article>
      </section>
    </main>
  )
}
